import { Box } from '@mui/material';

import { useParams } from '@redwoodjs/router';

import Loader from 'src/components/Loader/Loader';
import useMerchantApplication from 'src/hooks/useMerchantApplication';

import ContactMapSection from './components/ContactMapSection';
import MerchantInfoColumn from './components/MerchantInfoColumn';
import NotesSection from './components/NotesSection';
import ServiceDetailsSection from './components/ServiceDetailsSection';
import TitleSection from './components/TitleSection';

const CheckInCallDashboardPage = () => {
    const { serviceId } = useParams();
    const { data, loading } = useMerchantApplication(Number(serviceId));
    const PANEL_HEIGHT = 525;

    if (loading || !data) return <Loader />;

    return (
        <>
            <TitleSection
                serviceId={serviceId}
                onCompleteCall={() => {
                    /* TODO: implement Complete‑Call flow */
                }}
            />
            <Box display="flex" gap={2} mt={2}>
                <ContactMapSection
                    principals={data.merchantInformation.principals}
                    height={PANEL_HEIGHT}
                />

                <MerchantInfoColumn
                    tradingName={data.merchantInformation.aboutBusiness.tradingName}
                    merchantAccountNumber={data.merchantAccountNumber}
                    mid={data.mid}
                    partnerName={data.partner.business.legalName}
                    partnerId={data.partnerId}
                    height={PANEL_HEIGHT}
                />
            </Box>
            <ServiceDetailsSection
                contractUrl={data.contract}
                terminalId={data.terminalId}
                orderPrimary={data.serviceRequirements?.productOrder?.primaryProducts}
                orderSecondary={data.serviceRequirements?.productOrder?.secondaryProducts}
                orderPrimaryUrls={data.serviceRequirements?.order?.primary}
                orderSecondaryUrls={data.serviceRequirements?.order?.secondary}
            />
            <NotesSection />
        </>
    );
};

export default CheckInCallDashboardPage;
